// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"524":"app","884":"admin"}[chunkId] || chunkId) + "." + {"245":"9c2ff427ea41f27ccd9a","345":"07e81a2a31370d4bd30c","524":"1791d3df714ebc23766a","532":"0e3109ad02cfe235fec3","708":"57be1c1794147b88065a","884":"b80b6a8c753395f4826a","912":"1a6fdcf4a5e5fa825ed0","963":"3f479896b2e6c432b6f3"}[chunkId] + ".js";
};